import * as React from 'react';

import AddStudents from './add_students';
import SetupInstructions from './setup_instructions';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

const closeIconSrc = `${window.postbuildEnv.CDN_URL}/images/icons/close.svg`;

interface InviteStudentsModalProps {
  classroom: any;
  close: (event: any) => void;
  showSnackbar: (event: any) => void;
}

const InviteStudentsModal: React.FC<InviteStudentsModalProps> = ({ classroom: initialClassroom, close, showSnackbar }) => {
  const { modalRef, } = useModalAccessibility(close)

  const [classroom, setClassroom] = React.useState<any>(initialClassroom);
  const [step, setStep] = React.useState<number>(1);

  const setStudents = (students: any) => {
    setClassroom((prevClassroom: any) => ({ ...prevClassroom, students }));
  };

  const next = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const back = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const renderHeader = () => (
    <div className="create-a-class-modal-header">
      <div className="navigation">
        <p className={step === 1 ? 'active' : ''}>1. Add students</p>
        <p className={step === 2 ? 'active' : ''}>2. Setup instructions</p>
      </div>
      <button className="interactive-wrapper focus-on-light" onClick={close} type="button">
        <img alt="Close icon" src={closeIconSrc} />
      </button>
    </div>
  );

  const renderModalContent = () => {
    if (step === 1) {
      return (
        <AddStudents
          classroom={classroom}
          close={close}
          next={next}
          setStudents={setStudents}
          showSnackbar={showSnackbar}
        />
      );
    }
    return (
      <SetupInstructions
        back={back}
        classroom={classroom}
        close={close}
      />
    );
  };

  return (
    <div className="modal-container create-a-class-modal-container">
      <div className="modal-background" />
      <div
        aria-label="Invite students"
        aria-modal="true"
        className="create-a-class-modal quill-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        {renderHeader()}
        {renderModalContent()}
      </div>
    </div>
  );
};

export default InviteStudentsModal;
